import {NavLink} from "react-router-dom";

const PageNavigation = (props) => {
    return ( <header style={{ width: '100%' }}>
        <nav className='top-nav'>
            <NavLink to="/repository_list"
                    style={({ isActive }) => ({
                        color: 'white',
                        textDecoration: isActive && 'underline',
                        fontWeight: isActive && 'bold',
                    })}>
                Repository List
            </NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <NavLink to="/data_definitions"
                    style={({ isActive }) => ({
                        color: 'white',
                        textDecoration: isActive && 'underline',
                        fontWeight: isActive && 'bold',
                    })}>
                Definitions
            </NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            
            {props.authString
                ? <>
                    <NavLink to="/repositories/management"
                            style={({isActive}) => ({
                                color: 'white',
                                textDecoration: isActive && 'underline',
                                fontWeight: isActive && 'bold',
                            })}>
                        Management
                    </NavLink>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <NavLink to="/logout"
                            onClick={() => props.clearAuthString()}
                            style={({isActive}) => ({
                                color: 'white',
                                textDecoration: isActive && 'underline',
                                fontWeight: isActive && 'bold',
                            })}>
                        Logout
                    </NavLink>
                </>
                : <NavLink to="/repositories/management"
                        style={({isActive}) => ({
                            color: 'white',
                            textDecoration: isActive && 'underline',
                            fontWeight: isActive && 'bold',
                        })}>
                    Login
                </NavLink>
            }
        </nav>
    </header> );
};

export default PageNavigation;